export const EVENTS = {
	OPTION_SELECTED: 'PredictiveSearchOptionSelected',
	SEARCH_RESULTS_RECEIVED: 'PredictiveSearchResultsReceived'
};


const PredictiveSearch = function(Alpine) {
	return Alpine.data('predictiveSearch', (limit: number = 8, containerId: string = 'PredictiveSearchResults') => ({
		resultsCount: 0,
		loading: false,
		lastKnownInput: null,
		searchInput: null,
		hasResults: false,
		isOpen: false,
		inFocus: false,
		autocompleteSearch() {
			this.lastKnownInput = this.searchInput;
			this.getSearchResults(this.searchInput);
		},
		getSearchResults(searchTerm: string) {	
			this.loading = true;
			let searchParams = `suggestion_limit=${limit}&resources[type]=product,query&resources[limit]=${limit}&resources[options][unavailable_products]=last&resources[limit_scope]=each`;
			const searchUrl = `/search/suggest?q=${searchTerm}&${searchParams}&section_id=predictive-search`;
	
			fetch(searchUrl).then((response) => {
				return response.text();
		  }).then((text) => {
			this.loading = false;

			const html = new DOMParser().parseFromString(text, 'text/html');
			Alpine.morph(document.getElementById(containerId), html.getElementById(containerId));
		  }).catch((error) => {
				this.close();
				throw error;
		  });
		},
		init() {
			this.$watch('resultsCount', (value: number) => {
				value > 0 ? this.hasResults = true : this.hasResults = false;
			});


			this.$watch('searchInput', (value) => {
				console.log('IN FOCUS', value);
			});
			

		}
	}));
};	

export default PredictiveSearch;